import React, { useState, useEffect } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { useCaseDetailReducer } from "../../../redux/slice/caseDetailSlice";
import { useComplaintReducer } from "../../../redux/slice/complaintSlice";
import { updateElementValueVideoConferenceReducer, useVideoConferenceReducer } from "../../../redux/slice/videoConferenceSlice"; // PR 11866 updateElementValueVideoConferenceReducer Added
import VideoConferenceSplitScreenMenu from "./VideoConferenceSplitScreenMenu";
import { INHOUSE_JITSI, JITSI_CLOUD } from "../../../constants/common"; // PR 11866 Added
import { useDispatch } from "react-redux"; // PR 11866 Added

type VideoConferenceSplitScreenPopUpProps = {
  show: boolean;
  onHide: () => void;
  isTestWebCam: boolean;
};
export default function VideoConferenceSplitScreenPopUp({
  show,
  onHide,
  isTestWebCam,
}: VideoConferenceSplitScreenPopUpProps) {
  const [scale, setScale] = useState(1);
  const [showSpliter, setShowSpliter] = useState(true);
  const [headerTxt, setHeaderTxt] = React.useState("");
  const { videoConferenceURL, videoConferenceStatus, videoConferenceType } = useVideoConferenceReducer(); // PR 11866 videoConferenceType Added
  const caseDetailReducer = useCaseDetailReducer();
  const ecomplaintReducer = useComplaintReducer();
  const handleDownload = () => { };
  const handlePrint = () => { };
  const dispatch = useDispatch(); // PR 11866 Added

  useEffect(() => {
    if (caseDetailReducer.searchWarrantId > 0) {
      const { caseNumber, countyName, searchWarrantId, complaintNumber } = caseDetailReducer;     // PR 11866 complaintNumber added
      if (searchWarrantId > 0)
        setHeaderTxt("Video Conference - " + countyName + " - " + (caseNumber ? caseNumber : complaintNumber));  // PR 11866
      else {
        const { caseNumber, complaintNumber, countyName } = ecomplaintReducer.complaintObject;
        let number = caseNumber ? caseNumber : complaintNumber;
        setHeaderTxt("Video Conference - " + countyName + " - " + number);
      }
    }
  }, [caseDetailReducer.searchWarrantId]);

  // PR 11866 Start 
  const hasOpenedConference = React.useRef(false);
  
  useEffect(() => {
    if (videoConferenceType === JITSI_CLOUD && videoConferenceURL) {
      if (videoConferenceURL === "Error") {
        dispatch(updateElementValueVideoConferenceReducer({
          elementName: 'videoConferenceURL',
          value: '/error'
        }));
      } else if (!hasOpenedConference.current) {
       
        window.open(videoConferenceURL, '_blank');
        hasOpenedConference.current = true;
        
        dispatch(updateElementValueVideoConferenceReducer({
          elementName: 'videoConferenceURL',
          value: ''
        }));
      }
    }

    return () => {
      hasOpenedConference.current = false;
    };
  }, [videoConferenceURL, videoConferenceType, dispatch]);
  // PR 11866 End

  return (
    <Modal
    // PR 11866 Start
    //show={show}
      show={videoConferenceType === INHOUSE_JITSI ? show : false} 
    // PR 11866 End
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
      backdrop="static"
      dialogClassName="modal-95w"
    >
      <Modal.Header closeButton>
        <div className="d-none d-lg-block position-fixed text-wrap" style={{ width: '29%' }}>
          {isTestWebCam ? "Test Webcam" : headerTxt} </div>
        <VideoConferenceSplitScreenMenu
          handleDownload={handleDownload}
          handleZoomIn={() => setScale(scale + 0.05)}
          handleZoomOut={() => setScale(scale - 0.05)}
          handleReset={() => setScale(1)}
          handlePrint={handlePrint}
          handleSplitScreen={() => setShowSpliter(!showSpliter)}
          showSpliter={showSpliter}
        />
      </Modal.Header>
      <Modal.Body
        className="modal-body-video"
        style={{
          minHeight: "78vh",
        }}
      >
        <div>
          <Container
            fluid
            style={{
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Row>
              <Col className="text-center">
                <div
                  style={{
                    height: "calc(80vh - 50px)",
                  }}
                >
                  <iframe
                    width="100%"
                    height="100%"
                    src={videoConferenceURL}
                    frameBorder="0"
                    allow="microphone; camera; display-capture; fullscreen; autoplay"
                    allowFullScreen={true}
                    title="Video Conference"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal.Body>
      <Modal.Footer> &nbsp; </Modal.Footer>
    </Modal>
  );
}
